import { Component, OnInit, Input } from '@angular/core';
import { GlobalState } from '../../../global.state';

@Component({
  selector: 'ubi-shell',
  templateUrl: './ubiShell.component.html',
  styleUrls: ['./ubiShell.component.scss']
})
export class UbiShellComponent implements OnInit {

  @Input() options: any;
  @Input() appTitle: string;
  @Input() user: any;

  constructor(private _state: GlobalState) {
    this._state.subscribe('content.header.css', (headerClass) => {
      this.options.headerClass = headerClass;
    });
  }

  ngOnInit() {
    const defaultOptions = {
      copyright: true,
      status: true,
      photo: true,
      profile: true,
      logout: true,
      search: false,
      msgcenter: {
        notifications: false,
        messages: false
      },
      headerClass: ''
    };

    this.options = Object.assign(defaultOptions, this.options);
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiShell/ubiShell.component.ts